import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/module/:id/class/:idx',
    component: () => import('layouts/VeryEmptyLayout.vue'),
    children: [
      {
        path: '',
        name: 'learning-class',
        component: () => import('pages/learning/Class.vue'),
      },
    ],
  },
  {
    path: '/access-test',
    component: () => import('layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/Access.vue'),
      },
    ],
    meta: {
      open: true,
    },
  },
  {
    path: '/module/:id/class/:idx/material/:idy',
    redirect: (to) => ({
      path: `/module/${to.params.id}/class/${to.params.idx}`,
      query: { ...to.query, materialId: to.params.idy },
    }),
  },
  {
    path: '/privacy',
    meta: {
      open: true,
    },
    component: () => import('layouts/EmptyLayout.vue'),
    children: [
      { path: '', component: () => import('pages/PrivacyPolicy.vue') },
    ],
  },
  {
    path: '/tos',
    meta: {
      open: true,
    },
    component: () => import('layouts/EmptyLayout.vue'),
    children: [
      { path: '', component: () => import('pages/TermsOfService.vue') },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('components/Interstitial.vue') },
      { path: '/lna', component: () => import('pages/lna/Index.vue') },
      {
        path: '/power-bi-instructions',
        component: () => import('pages/PowerBiInstructions.vue'),
      },
      {
        path: '/learning/dashboard',
        component: () => import('pages/learning/Dashboard.vue'),
      },
      {
        path: '/courses',
        component: () => import('pages/learning/MyCertifications.vue'),
      },
      {
        path: '/onboarding',
        component: () => import('pages/learning/Onboarding.vue'),
      },
      {
        path: '/learning/trophies',
        component: () => import('pages/learning/TrophyCabinet.vue'),
      },
      {
        path: '/learning/faq',
        component: () => import('pages/learning/FAQ.vue'),
      },
      {
        path: '/dashboard',
        component: () => import('pages/DashboardPage.vue'),
      },
      {
        path: '/coach',
        component: () => import('pages/Coach.vue'),
      },
      {
        path: '/support',
        component: () => import('pages/Support.vue'),
      },
      { path: '/users', component: () => import('pages/Users.vue') },
      { path: '/users/:id', component: () => import('pages/User.vue') },
      {
        path: '/lna/pas',
        component: () => import('pages/lna/PersonaAssociation.vue'),
      },
      {
        path: '/lna/kns',
        component: () => import('pages/lna/KnowledgeAndSkills.vue'),
      },
      {
        path: '/assessments',
        children: [
          {
            path: ':id',
            component: () => import('pages/Assessment.vue'),
            name: 'assessment',
          },
        ],
      },
      {
        path: '/assessment-report/:id',
        component: () => import('pages/AssessmentReport.vue'),
      },
      {
        path: '/manage/assessments',
        component: () => import('components/admin/Assessments.vue'),
      },
      {
        path: 'manage/coach-prompt-types',
        children: [
          {
            path: '',
            component: () =>
              import('pages/management/coach-prompt-types/Index.vue'),
            name: 'coachPromptTypes',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/coach-prompt-types/Create.vue'),
            name: 'createCoachPromptType',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/coach-prompt-types/Record.vue'),
            name: 'editCoachPromptType',
          },
        ],
      },
      {
        path: '/manage/coach-prompts',
        children: [
          {
            path: '',
            component: () => import('pages/management/coach-prompts/Index.vue'),
            name: 'coachPrompts',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/coach-prompts/Create.vue'),
            name: 'createCoachPrompt',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/coach-prompts/Record.vue'),
            name: 'editCoachPrompt',
          },
        ],
      },
      {
        path: '/manage/templates',
        component: () => import('pages/management/Templates.vue'),
      },
      {
        path: '/manage/enrolments',
        children: [
          {
            path: '',
            component: () => import('pages/management/enrolments/Index.vue'),
            name: 'enrolments',
          },
          {
            path: 'create',
            component: () => import('pages/management/enrolments/Create.vue'),
            name: 'createEnrolment',
          },
          {
            path: ':id',
            component: () => import('pages/management/enrolments/Record.vue'),
            name: 'editEnrolment',
          },
        ],
      },
      {
        path: '/manage/cohorts',
        children: [
          {
            path: '',
            component: () => import('pages/management/cohorts/Index.vue'),
            name: 'cohorts',
          },
          {
            path: 'planner/:moduleId',
            component: () => import('pages/management/cohorts/Planner.vue'),
            name: 'schedulePlanner',
          },
        ],
      },
      {
        path: '/manage/nomination-lists',
        children: [
          {
            path: '',
            component: () =>
              import('pages/management/nomination-lists/Index.vue'),
            name: 'nominationLists',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/nomination-lists/Create.vue'),
            name: 'createNominationList',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/nomination-lists/Record.vue'),
            name: 'nominationListRecord',
            meta: {
              readOnly: true,
            },
          },
        ],
      },
      {
        path: '/manage/intakes',
        children: [
          {
            path: '',
            component: () => import('pages/management/intakes/Index.vue'),
            name: 'intakes',
          },
          {
            path: 'create',
            component: () => import('pages/management/intakes/Create.vue'),
            name: 'createIntake',
          },
          {
            path: ':id',
            component: () => import('pages/management/intakes/Record.vue'),
          },
          {
            path: ':id/import',
            component: () => import('pages/management/intakes/Import.vue'),
          },
        ],
      },
      {
        path: '/manage/learners',
        children: [
          {
            path: '',
            component: () => import('pages/management/learners/Index.vue'),
            name: 'learners',
          },
          {
            path: ':id',
            component: () => import('pages/management/learners/Record.vue'),
            name: 'editLearner',
          },
        ],
      },
      {
        path: '/manage/organisations',
        children: [
          {
            path: '',
            component: () => import('pages/management/organisations/Index.vue'),
            name: 'organisations',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/organisations/Create.vue'),
            name: 'createOrganisation',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/organisations/Record.vue'),
            name: 'editOrganisation',
          },
        ],
      },
      {
        path: '/manage/lessons',
        children: [
          {
            path: '',
            component: () => import('pages/management/lessons/Index.vue'),
            name: 'lessons',
          },
          {
            path: 'create',
            component: () => import('pages/management/lessons/Create.vue'),
            name: 'createLesson',
          },
          {
            path: ':id',
            component: () => import('pages/management/lessons/Record.vue'),
            name: 'editLesson',
          },
        ],
      },
      {
        path: '/manage/users',
        children: [
          {
            path: '',
            component: () => import('pages/management/users/Index.vue'),
            name: 'users',
          },
          {
            path: 'create',
            component: () => import('pages/management/users/Create.vue'),
            name: 'createUser',
          },
          {
            path: ':id',
            component: () => import('pages/management/users/Record.vue'),
            name: 'editUser',
          },
        ],
      },
      {
        path: '/manage/certifications',
        children: [
          {
            path: '',
            component: () =>
              import('pages/management/certifications/Index.vue'),
            name: 'certifications',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/certifications/Create.vue'),
            name: 'createCertification',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/certifications/Record.vue'),
            name: 'editCertification',
          },
        ],
      },
      {
        path: '/manage/classes',
        component: () => import('pages/management/Classes.vue'),
      },
      {
        path: '/manage/contractors',
        children: [
          {
            path: '',
            component: () => import('pages/management/contractors/Index.vue'),
            name: 'contractors',
          },
          {
            path: 'create',
            component: () => import('pages/management/contractors/Create.vue'),
            name: 'createContractor',
          },
          {
            path: ':id',
            component: () => import('pages/management/contractors/Record.vue'),
            name: 'editContractor',
          },
        ],
      },
      {
        path: '/contractor/record',
        component: () => import('pages/contractor/Record.vue'),
        name: 'contractorRecord',
      },
      {
        path: '/module/:id',
        name: 'module',
        component: () => import('pages/ModuleV2.vue'),
      },
      {
        path: '/manage/modules',
        children: [
          {
            path: '',
            component: () => import('pages/management/modules/Index.vue'),
            name: 'modules',
          },
          {
            path: ':id',
            component: () => import('pages/management/modules/Record.vue'),
            name: 'editModule',
          },
        ],
      },
      {
        path: '/manage/ondemand-modules',
        children: [
          {
            path: '',
            component: () =>
              import('pages/management/self-serve-modules/Index.vue'),
            name: 'ssModules',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/self-serve-modules/Create.vue'),
            name: 'createSSModule',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/self-serve-modules/Record.vue'),
            name: 'editSSModule',
          },
        ],
      },
      {
        path: '/manage/ondemand-tracks',
        children: [
          {
            path: '',
            component: () =>
              import('pages/management/on-demand-tracks/Index.vue'),
            name: 'odTracks',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/on-demand-tracks/Create.vue'),
            name: 'createOdTrack',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/on-demand-tracks/Record.vue'),
            name: 'editOdTrack',
          },
        ],
      },
      {
        path: '/manage/learning-objectives',
        children: [
          {
            path: '',
            component: () =>
              import('pages/management/learning-objectives/Index.vue'),
            name: 'learningObjectives',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/learning-objectives/Create.vue'),
            name: 'createLearningObjective',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/learning-objectives/Record.vue'),
            name: 'editLearningObjective',
          },
        ],
      },
      {
        path: 'manage/pages',
        children: [
          {
            path: '',
            component: () =>
              import('pages/management/self-serve-pages/Index.vue'),
            name: 'pages',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/self-serve-pages/Create.vue'),
            name: 'createPage',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/self-serve-pages/Record.vue'),
            name: 'editPage',
          },
        ],
      },
      {
        path: '/manage/masterclasses',
        children: [
          {
            path: '',
            component: () => import('pages/management/masterclasses/Index.vue'),
            name: 'masterclasses',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/masterclasses/Create.vue'),
            name: 'createMasterclass',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/masterclasses/Record.vue'),
            name: 'editMasterclass',
          },
        ],
      },
      {
        path: '/manage/masterclass-templates',
        children: [
          {
            path: '',
            component: () =>
              import('pages/management/masterclass-templates/Index.vue'),
            name: 'masterclassTemplates',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/masterclass-templates/Create.vue'),
            name: 'createMasterclassTemplate',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/masterclass-templates/Record.vue'),
            name: 'editMasterclassTemplate',
          },
        ],
      },
      {
        path: 'manage/survey-questions',
        children: [
          {
            path: '',
            component: () =>
              import('pages/management/survey-questions/Index.vue'),
            name: 'surveyQuestions',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/survey-questions/Create.vue'),
            name: 'createSurveyQuestion',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/survey-questions/Record.vue'),
            name: 'editSurveyQuestion',
          },
        ],
      },
      {
        path: 'manage/surveys',
        children: [
          {
            path: '',
            component: () => import('pages/management/surveys/Index.vue'),
            name: 'surveys',
          },
          {
            path: 'create',
            component: () => import('pages/management/surveys/Create.vue'),
            name: 'createSurvey',
          },
          {
            path: ':id',
            component: () => import('pages/management/surveys/Record.vue'),
            name: 'editSurvey',
          },
          {
            path: ':id/iframe',
            component: () => import('pages/management/surveys/Iframe.vue'),
            name: 'iframeSurvey',
          },
        ],
      },
      {
        path: 'manage/survey-questions',
        children: [
          {
            path: '',
            component: () =>
              import('pages/management/survey-questions/Index.vue'),
            name: 'surveyQuestions',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/survey-questions/Create.vue'),
            name: 'createSurveyQuestion',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/survey-questions/Record.vue'),
            name: 'editSurveyQuestion',
          },
        ],
      },
      {
        path: '/manage/active-modules',
        component: () => import('pages/management/ActiveModules.vue'),
      },
      {
        path: '/manage/comms-templates/:id?',
        component: () => import('pages/management/CommsTemplates.vue'),
      },
      {
        path: '/manage/comms',
        component: () => import('pages/management/Comms.vue'),
      },
      {
        path: '/manage/global-banner',
        component: () => import('pages/management/GlobalBanner.vue'),
        name: 'globalBanner',
      },
      {
        path: '/manage/activities',
        component: () => import('pages/management/activities/Index.vue'),
      },
      {
        path: '/manage/spreadsheet-exercises',
        children: [
          {
            path: '',
            component: () =>
              import('pages/management/spreadsheet-exercises/Index.vue'),
            name: 'spreadsheetExercises',
          },
          {
            path: 'create',
            component: () =>
              import('pages/management/spreadsheet-exercises/Record.vue'),
            name: 'createSpreadsheetExercise',
          },
          {
            path: ':id',
            component: () =>
              import('pages/management/spreadsheet-exercises/Record.vue'),
            name: 'editSpreadsheetExercise',
          },
        ],
      },
      {
        path: '/reports/invites',
        component: () => import('pages/reports/Invites.vue'),
      },
      {
        path: '/reports/ondemand',
        component: () => import('pages/reports/OnDemand.vue'),
      },
      {
        path: '/reports/live-learning',
        component: () => import('pages/reports/LiveLearning.vue'),
      },
      {
        path: '/reports/lvrm',
        component: () => import('pages/reports/LVRM.vue'),
      },
      {
        path: '/education',
        component: () => import('pages/education/Index.vue'),
      },
      {
        path: '/reports/admin/invites',
        component: () => import('pages/reports/admin/Invites.vue'),
      },
      {
        path: '/reports/admin/live-learning',
        component: () => import('pages/reports/admin/LiveLearning.vue'),
      },
      {
        path: '/reports/admin/lvrm',
        component: () => import('pages/reports/admin/LVRM.vue'),
      },
      {
        path: '/reports/admin/ondemand',
        component: () => import('pages/reports/admin/OnDemand.vue'),
      },
      {
        path: '/admin-overview',
        component: () => import('pages/admin/AdminDashboard.vue'),
        name: 'adminDashboard',
      },
      {
        path: '/surveys/:id',
        component: () => import('pages/learning/Survey.vue'),
      },
    ],
  },
  {
    path: '/login',
    component: () => import('layouts/EmptyLayout.vue'),
    children: [{ path: '', component: () => import('src/pages/Login.vue') }],
  },
  {
    path: '/auto-login',
    component: () => import('layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/pages/auth/AutoLogin.vue'),
        name: 'autoLogin',
      },
    ],
  },
  {
    path: '/sso',
    component: () => import('layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/pages/auth/sso.vue'),
        name: 'sso',
      },
    ],
  },
  {
    path: '/manage/activities/:id/preview',
    component: () => import('layouts/PreviewLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/management/activities/Preview.vue'),
        name: 'previewActivity',
      },
    ],
  },
  {
    path: '/manage/surveys/:id/preview',
    component: () => import('layouts/PreviewLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/management/surveys/Preview.vue'),
        name: 'previewSurvey',
      },
    ],
  },
  {
    path: '/learners/:id',
    component: () => import('layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/pages/LearnerList.vue'),
        name: 'learnerList',
      },
    ],
  },
  {
    path: '/register',
    component: () => import('layouts/EmptyLayout.vue'),
    children: [{ path: '', component: () => import('pages/Register.vue') }],
    meta: {
      open: true,
    },
  },
  {
    path: '/auth',
    component: () => import('pages/AuthRedirect.vue'),
    meta: {
      open: true,
    },
  },
  {
    path: '/formkit-testing',
    component: () => import('pages/FormkitTesting.vue'),
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
